/**
 * InputType `MarkdownDisplay` -- a labelled, read-only field that renders the markdown held in its
 * value. Use it for a remark a user typed; use InputType `Markdown` for static markdown authored in
 * the manifest (an Instructions block), which is what that one's templates are gated for.
 *
 * Like `Markdown`, this has no Tabular templates: the display element is addressed per input, not
 * per row.
 */
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
